import AppContext, { AppContextProps } from 'containers/context/Context'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useSearchParams } from 'react-router-dom'
import { REPORT_PATH } from '../Report/Routes'
import { CryptoHelper } from 'containers/helper/Crypto/Crypto'
import { setAccessToken } from 'AccessToken'
import { DEVEXPRESS_PATH } from '../DexExpress/Routes'
import { useGetReportListLazyQuery } from 'generated/graphql'

const AutoLogin = () => {
  let navigate = useNavigate()
  const { rootState, rootDispatch } =
    React.useContext<AppContextProps>(AppContext)
  const [searchParams] = useSearchParams()
  const [hasTokenSet, setHasTokenSet] = React.useState(false)

  //#region get report listing
  const [getReportListing, { data }] = useGetReportListLazyQuery()
  //#endregion

  useEffect(() => {
    let q = searchParams.get('q')

    const accessToken = CryptoHelper.decryption(q.replace(/ /g, '+'), 'base64')
    localStorage.setItem('key', CryptoHelper.encryption(accessToken))
    setAccessToken(accessToken)
    // sessionStorage.setItem(
    //   'tokenKey',
    //   CryptoHelper.decryption(q.replace(/ /g, '+'), 'base64')
    // )\

    setHasTokenSet(true)
  }, [])

  useEffect(() => {
    if (!hasTokenSet) return
    // Redirect to Specific Report from Sales Admin
    let reportName = searchParams.get('reportName')
    let parameterString = searchParams.get('parameter')

    if (reportName && parameterString) {
      const parametersList = parameterString.split(',')

      getReportListing({ variables: { categoryId: '0' } }).then(({ data }) => {
        const matchedReport = data?.getReportList.find(
          report => report.reportName.toLowerCase() === reportName.toLowerCase()
        )
        if (matchedReport) {
          navigate(`${DEVEXPRESS_PATH.VIEWER}/${matchedReport?.reportId}`, {
            state: {
              reportName: reportName,
              parameter: parametersList.join('&'),
            },
          })
        }
      })
    } else navigate(REPORT_PATH.DASHBOARD) //report listing page
  })

  return (
    <>
      <div>auto login</div>
    </>
  )
}

export default AutoLogin
